import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import History from 'Store/history';

const RegisterLoginButtons = ({ openLoginPanel, isDesktop, toggleMenu }) => {

  return (
    <div className="header-login__buttons">
      <Link className="btn btn-register btn-register--margin-new-banner" to={ '/uye-ol' } title="Üye Ol" rel="nofollow">
        Üye Ol
      </Link>
      <a title={ 'Giriş Yap' } rel="nofollow" className="btn btn-login btn-login--margin-new-banner"
        onClick={ () => isDesktop ? openLoginPanel() : History.push('/giris-yap') }>
        Giriş Yap
      </a>
      <div className="header-login__hamburger" onClick={ () => toggleMenu() }>
        <i className="bly bly-hamburger-menu bly-white bly-size20"/>
      </div>
    </div>
  );
};

RegisterLoginButtons.propTypes = {
  openLoginPanel: PropTypes.func,
  isDesktop: PropTypes.bool,
  toggleMenu: PropTypes.func
};

export default RegisterLoginButtons;
